class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("menulink:click", (event) => {
      this.show();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.classList.contains("state--active")) {
        this.hide();
      }
    });
  }

  connectedCallback() {
    if (Theme.URLParams.has("menu")) {
      this.show();
    }
  }

  show() {
    Theme.URLParams.set("menu", "open");

    this.returnFocus = document.activeElement;

    setTimeout(() => {
      this.classList.add("state--active");

      const dialog = this.querySelector(".menu-content");

      dialog?.addEventListener("transitionend", () => dialog.focus({ preventScroll: true }), { once: true });
      setTimeout(() => dialog?.focus({ preventScroll: true }), 400);
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");

    Theme.URLParams.delete("menu");
    this.returnFocus?.focus?.({ preventScroll: true });
    this.returnFocus = null;
  }
}

customElements.define("menu-drawer", MenuDrawer);

class MenuOverlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-overlay", MenuOverlay);


class MenuClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-close", MenuClose);


class MenuAccordion extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector(".menu-drawer-accordion-header");
    this.panel = this.querySelector(".menu-drawer-accordion-content");
    this.nav = this.closest(".menu-drawer-nav");

    if (!this.trigger) {
      return;
    }

    this.onClick = () => this.toggle();
    this.onScroll = () => this.measure();

    this.trigger.addEventListener("click", this.onClick);

    if (this.panel) {
      this.panel.addEventListener("scroll", this.onScroll, { passive: true });

      this.observer = new ResizeObserver(this.onScroll);
      this.observer.observe(this.panel);
    }

    this.measure();
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener("click", this.onClick);
    }

    if (this.panel) {
      this.panel.removeEventListener("scroll", this.onScroll);
      this.observer.disconnect();
    }
  }

  toggle() {
    const open = this.classList.toggle("state--active");

    this.trigger.setAttribute("aria-expanded", open ? "true" : "false");

    this.measure();
  }

  measure() {
    if (!this.nav || !this.panel) {
      return;
    }

    const open = this.classList.contains("state--active");
    const top = open && this.panel.scrollTop > 0 ? 1 : 0;

    this.style.setProperty("--scroll-fade-top", top);
  }
}

customElements.define("menu-accordion", MenuAccordion);
